import React from 'react';
import type { SchoolReportType, SchoolViewType } from '../../types';
import type { ManageMetricsType } from '../../../forms/types';
import SchoolReportTable from '../sections/SchoolReportTable';

type Props = {
  schoolReport: SchoolReportType;
  filteredIds: number[] | null;
  classYearValue: SchoolViewType;
  showOthersData: boolean;
  metricsSettings: ManageMetricsType;
};

const SchoolTablesView = ({ schoolReport, filteredIds, classYearValue, showOthersData, metricsSettings }: Props): JSX.Element => {

  const schoolReportToUse =
    { groups: classYearValue === 'class' ? schoolReport.classes : schoolReport.yearGroups,
      average: classYearValue === 'class' ? schoolReport.average : schoolReport.yearGroupsAverage,
    };

  return (
    <div id={'table-container'}>
      <SchoolReportTable
        schoolReport={schoolReportToUse}
        highlightedIds={filteredIds}
        classYearValue={classYearValue}
        showOthersData={showOthersData}
        metricsSettings={metricsSettings}
      />
    </div>
  );
};

SchoolTablesView.displayName = 'SchoolTablesView';

export default SchoolTablesView;
